// Info: Contains App specific Constants
"use strict";
import axios from "axios";

export default function UploadImageS3(cropImage, upload_data, cb, progressCb = null) {
  const formData = new FormData();
  formData.append("Policy", upload_data.fields["Policy"]);
  formData.append("X-Amz-Algorithm", upload_data.fields["X-Amz-Algorithm"]);
  formData.append("X-Amz-Credential", upload_data.fields["X-Amz-Credential"]);
  formData.append("X-Amz-Date", upload_data.fields["X-Amz-Date"]);
  formData.append("X-Amz-Signature", upload_data.fields["X-Amz-Signature"]);
  formData.append("bucket", upload_data.fields["bucket"]);
  formData.append("content-type", upload_data.fields["content-type"]);
  formData.append("key", upload_data.fields["key"]);
  formData.append("file", cropImage);

  const headers = {
    "Content-Type": "multipart/form-data", // Important for file upload
  };

  const config = {
    headers,
    onUploadProgress: (progressEvent) => {
      if (progressCb && progressEvent.total) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        // Map S3 upload progress from 40% to 95% range
        const mappedProgress = 40 + Math.round((percentCompleted * 55) / 100);
        progressCb(mappedProgress);
      }
    }
  };

  axios
    .post(upload_data.url, formData, config)
    .then((response) => {
      if (progressCb) {
        progressCb(100); // Set to 100% on success
      }
      cb(false);
    })
    .catch((error) => {
      cb(error);
    });
}
